function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BackgroundStyle } from './StatusIndicator.theme.utils';

var getStatusIndicatorStyles = (status, hasChildren) => {
  var isStatusSecondary = status === 'secondary';
  var backgroundColor = isStatusSecondary ? 'neutral.white' : BackgroundStyle[status];
  var border = isStatusSecondary ? 'input-thick.readOnly' : hasChildren ? '2px solid #fff' : 'none';
  return {
    backgroundColor,
    border
  };
};

var getDisabledStatusIndicatorStyles = (status, hasChildren) => {
  var isStatusSecondary = status === 'secondary';
  var backgroundColor = isStatusSecondary ? 'neutral.white' : 'neutral.light';
  var border = isStatusSecondary ? 'input-thick.disabled' : hasChildren ? '2px solid #fff' : 'none';
  return {
    backgroundColor,
    border
  };
};

export var statusIndicatorTheme = {
  baseStyle: _ref => {
    var {
      status,
      hasChildren
    } = _ref;
    return {
      container: {
        display: 'flex',
        position: 'relative',
        width: 'fit-content'
      },
      indicator: _objectSpread(_objectSpread({
        position: hasChildren ? 'absolute' : 'relative',
        top: hasChildren ? '-2px' : '0',
        right: hasChildren ? '-2px' : '0',
        pointerEvents: hasChildren ? 'none' : 'all',
        boxSizing: status === 'secondary' ? 'border-box' : 'content-box',
        display: 'inline-flex',
        height: '8px',
        width: '8px',
        borderRadius: 'full',
        zIndex: 1
      }, getStatusIndicatorStyles(status, hasChildren)), {}, {
        _disabled: _objectSpread(_objectSpread({}, getDisabledStatusIndicatorStyles(status, hasChildren)), {}, {
          display: hasChildren ? 'none' : 'inline-flex'
        }),
        _readOnly: {
          backgroundColor: status === 'secondary' ? 'neutral.white' : 'neutral.darker'
        }
      })
    };
  },
  defaultProps: {
    status: 'brand'
  }
};
//# sourceMappingURL=StatusIndicator.theme.js.map